// Redirecting to the calculator inside the app if the user is logged in
export default defineNuxtRouteMiddleware(async (to) => {
  const user = useSupabaseUser()
  if (user.value) {
    return {
      path: '/tools/calculator',
      query: to.query,
    }
  }
})